<div id="ch-ggs-web-suite-content-step">
  <div class="step-container">
    <ol
      class="ch-ggs-web-suite-steps d-flex justify-content-start align-items-center"
    >
      <ng-container *ngFor="let step of steps; let i = index">
        <li
          *ngIf="step.show"
          (click)="!step.isActive && !step.isDisabled && selectStep.emit(i)"
          [class.clickable]="!step.isDisabled"
          [class.active]="step.isActive"
        >
          <span *ngIf="async">
            {{ step.label | async }}
          </span>
          <span *ngIf="!async">
            {{ step.label }}
          </span>
        </li>
      </ng-container>
    </ol>
  </div>
</div>
